const rootActionPath = 'core/curatedActiveMerchants';

export const CURATED_ACTIVE_MERCHANTS_VIEW = `${rootActionPath}/VIEW`;
